import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate, Outlet } from "react-router-dom";
import { LayoutDashboard, BookOpen, Users, ShoppingCart, Tag, Percent, MessageSquare, HelpCircle, Settings, LogOut, Mail, FileText, ShieldCheck, Activity, Briefcase } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/courses", label: "Courses", icon: BookOpen },
  { to: "/admin/services", label: "Services", icon: Briefcase },
  { to: "/admin/orders", label: "Orders", icon: ShoppingCart },
  { to: "/admin/students", label: "Students", icon: Users },
  { to: "/admin/offers", label: "Offers", icon: Tag },
  { to: "/admin/coupons", label: "Coupons", icon: Percent },
  { to: "/admin/testimonials", label: "Testimonials", icon: MessageSquare },
  { to: "/admin/faqs", label: "FAQs", icon: HelpCircle },
  { to: "/admin/messages", label: "Messages", icon: Mail },
  { to: "/admin/site-content", label: "Site Content", icon: FileText },
  { to: "/admin/admins", label: "Admins", icon: ShieldCheck },
  { to: "/admin/activity", label: "Activity", icon: Activity },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
  const { user, logout, loading } = useAuth();
  const nav = useNavigate();
  useEffect(() => {
    if (!loading && (!user || user.role !== "admin")) nav("/admin/login", { replace: true });
  }, [user, loading, nav]);
  if (!user) return null;

  return (
    <div className="min-h-screen flex text-ink-900">
      <aside className="w-64 border-r border-ink-900/10 bg-cream-50 p-6 hidden md:flex flex-col" data-testid="admin-sidebar">
        <Link to="/" className="font-display font-bold tracking-tight text-lg">NIRAJ <span className="text-gold">BHAARDWAJ</span></Link>
        <div className="mt-1 text-xs text-ink-500 tracking-widest uppercase">Admin</div>
        <nav className="mt-10 space-y-1 flex-1">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2 rounded-lg text-sm ${isActive ? "bg-gold/10 text-ink-900" : "text-ink-600 hover:bg-ink-900/[0.04] hover:text-ink-900"}`}
              data-testid={`admin-nav-${n.label.toLowerCase().replace(/ /g,'-')}`}>
              <n.icon className="w-4 h-4" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <button onClick={async () => { await logout(); nav("/"); }} className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-ink-600 hover:text-ink-900" data-testid="admin-logout">
          <LogOut className="w-4 h-4" /> Logout
        </button>
      </aside>
      <main className="flex-1 min-w-0"><div className="p-6 md:p-10"><Outlet /></div></main>
    </div>
  );
}
